const personnel = () => ({
    getEdit: false,
    PERSONNEL_ID:"",
    PERSONNEL_CID:"",
    PERSONNEL_NAMETYPE:"",
    PERSONNEL_NAME:"",
    PERSONNEL_LASTNAME:"",
    PERSONNEL_ADDRESS:"",
    PERSONNEL_PHONE:"",
    PERSONNEL_POSITION:"",
    PERSONNEL_SUBDISTRICT:"",
    PERSONNEL_DISTRICT:"",
    PERSONNEL_PROVINCE:"",
    PERSONNEL_ZIPCODE:"",
})

const state = personnel()

const getters = {
    getEdit: state => state.getEdit,
    PERSONNEL_ID: state => state.PERSONNEL_ID,
    PERSONNEL_CID: state => state.PERSONNEL_CID,
    PERSONNEL_NAMETYPE:state => state.PERSONNEL_NAMETYPE,
    PERSONNEL_NAME:state => state.PERSONNEL_NAME,
    PERSONNEL_LASTNAME:state => state.PERSONNEL_LASTNAME,
    PERSONNEL_ADDRESS:state => state.PERSONNEL_ADDRESS,
    PERSONNEL_PHONE:state => state.PERSONNEL_PHONE,
    PERSONNEL_POSITION:state => state.PERSONNEL_POSITION,
    PERSONNEL_SUBDISTRICT:state => state.PERSONNEL_SUBDISTRICT,
    PERSONNEL_DISTRICT:state => state.PERSONNEL_DISTRICT,
    PERSONNEL_PROVINCE:state => state.PERSONNEL_PROVINCE,
    PERSONNEL_ZIPCODE:state => state.PERSONNEL_ZIPCODE,
}
const mutations = {
    SET_getEdit(state, data) {
        state.getEdit = data
    },
    RESET(state) {
        const newState = personnel();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },
    SET_PERSONNEL_ID(state, data) {
        state.PERSONNEL_ID = data
    },
    SET_PERSONNEL_CID(state, data) {
        state.PERSONNEL_CID = data
    },
    SET_PERSONNEL_NAMETYPE(state, data) {
        state.PERSONNEL_NAMETYPE = data
    },
    SET_PERSONNEL_NAME(state, data) {
        state.PERSONNEL_NAME = data
    },
    SET_PERSONNEL_LASTNAME(state, data) {
        state.PERSONNEL_LASTNAME = data
    },
    SET_PERSONNEL_ADDRESS(state, data) {
        state.PERSONNEL_ADDRESS = data
    },
    SET_PERSONNEL_PHONE(state, data) {
        state.PERSONNEL_PHONE = data
    },
    SET_PERSONNEL_POSITION(state, data) {
        state.PERSONNEL_POSITION = data
    },
    SET_PERSONNEL_SUBDISTRICT(state, data) {
        state.PERSONNEL_SUBDISTRICT = data
    },
    SET_PERSONNEL_DISTRICT(state, data) {
        state.PERSONNEL_DISTRICT = data
    },
    SET_PERSONNEL_PROVINCE(state, data) {
        state.PERSONNEL_PROVINCE = data
    },
    SET_PERSONNEL_ZIPCODE(state, data) {
        state.PERSONNEL_ZIPCODE = data
    },

}

const actions = {
    // fetchVariable1({ commit }) {
    //     return new Promise( (resolve, reject) => {
    //            // Make network request and fetch data
    //            // and commit the data
    //            commit('SET_VARIABLE_1', data); 
    //            resolve();
    //     })
    // }
    // remove_weight_contract(context, items){
    //     let data = context.state.WEIGHT_CONTRACT
    //     const index =  data.indexOf(items)
    //     data.splice(index, 1);
    //     context.commit('SET_WEIGHT_CONTRACT',data)
    // },
    preson_reset({ commit }) {
        commit('RESET');
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}